import { userService } from '../services';
import { alertActions } from './alert';

const REGISTER_REQUEST = 'registration/REGISTER_REQUEST';
const REGISTER_SUCCESS = 'registration/REGISTER_SUCCESS';
const REGISTER_FAILURE = 'registration/REGISTER_FAILURE';

const register = (user) => {
    return dispatch => {
        dispatch(request(user));

        userService.register(user)
            .then(
                user => { 
                    dispatch(success());
                    dispatch(alertActions.success('가입을 성공하였습니다.', '/'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: REGISTER_REQUEST, user } }
    function success(user) { return { type: REGISTER_SUCCESS, user } }
    function failure(error) { return { type: REGISTER_FAILURE, error } }
};

export const registrationActions = {
    register,
};


function registration(state = {}, action) {
    switch (action.type) {
        case REGISTER_REQUEST:
            return { registering: true };
        case REGISTER_SUCCESS:
            return {};
        case REGISTER_FAILURE:
            return {};
        default:
            return state
    }
}

export default registration;